import React, { forwardRef } from 'react'
import {
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  TextBody,
  TextBodySmall,
  TextBodyXSmall,
} from '../../styles/vars/textStyles.style'

const ThisHeading1 = forwardRef(
  ({ children, as, color, maxWidth, ...props }, ref) => (
    <Heading1 ref={ref} as={as} color={color} maxWidth={maxWidth} {...props}>
      {children}
    </Heading1>
  )
)

const ThisHeading2 = forwardRef(
  ({ children, as, color, maxWidth, ...props }, ref) => (
    <Heading2 ref={ref} as={as} color={color} maxWidth={maxWidth} {...props}>
      {children}
    </Heading2>
  )
)

const ThisHeading3 = forwardRef(
  ({ children, as, color, maxWidth, ...props }, ref) => (
    <Heading3 ref={ref} as={as} color={color} maxWidth={maxWidth} {...props}>
      {children}
    </Heading3>
  )
)

const ThisHeading4 = forwardRef(
  ({ children, as, color, maxWidth, ...props }, ref) => (
    <Heading4 ref={ref} as={as} color={color} maxWidth={maxWidth} {...props}>
      {children}
    </Heading4>
  )
)

const ThisTextBody = forwardRef(
  ({ children, as, color, maxWidth, ...props }, ref) => (
    <TextBody ref={ref} as={as} color={color} maxWidth={maxWidth} {...props}>
      {children}
    </TextBody>
  )
)

const ThisTextBodySmall = forwardRef(
  ({ children, as, color, maxWidth, ...props }, ref) => (
    <TextBodySmall
      ref={ref}
      as={as}
      color={color}
      maxWidth={maxWidth}
      {...props}
    >
      {children}
    </TextBodySmall>
  )
)

const ThisTextBodyXSmall = forwardRef(
  ({ children, as, color, maxWidth, ...props }, ref) => (
    <TextBodyXSmall
      ref={ref}
      as={as}
      color={color}
      maxWidth={maxWidth}
      {...props}
    >
      {children}
    </TextBodyXSmall>
  )
)

export {
  ThisHeading1 as Heading1,
  ThisHeading2 as Heading2,
  ThisHeading3 as Heading3,
  ThisHeading4 as Heading4,
  ThisTextBody as TextBody,
  ThisTextBodySmall as TextBodySmall,
  ThisTextBodyXSmall as TextBodyXSmall,
}
